import { useState } from "react";
import { ApiClient, ProblemDetailError } from "../api/client";

type SetupApi = Pick<ApiClient, "createSetupAdmin">;

type Props = {
  setupToken: string | null;
  tokenValid: boolean | null;
  onCreated: () => void;
  apiClient?: SetupApi;
};

export function SetupAdminScreen({
  setupToken,
  tokenValid,
  onCreated,
  apiClient,
}: Props): JSX.Element {
  const client = apiClient ?? new ApiClient();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const blocked = setupToken === null || tokenValid === false;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (blocked || setupToken === null) return;
    setError(null);
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setBusy(true);
    try {
      await client.createSetupAdmin({
        setup_token: setupToken,
        username: username.trim(),
        password,
      });
      setBusy(false);
      onCreated();
    } catch (err) {
      setBusy(false);
      if (err instanceof ProblemDetailError) {
        setError(err.detail || err.title);
      } else {
        setError("Setup failed. Check the network and try again.");
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: "1rem",
      }}
    >
      <h1>tradepro setup</h1>
      <form
        onSubmit={submit}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "0.75rem",
          width: "340px",
        }}
      >
        {blocked && (
          <div role="alert" style={{ color: "#c33", fontSize: "0.85rem" }}>
            Use the one-time setup URL generated on the server.
          </div>
        )}
        <label htmlFor="setup-username" style={{ fontSize: "0.85rem" }}>
          Admin username
          <input
            id="setup-username"
            type="text"
            autoComplete="username"
            autoFocus
            disabled={blocked || busy}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{ width: "100%", padding: "0.5rem", marginTop: "0.25rem" }}
          />
        </label>
        <label htmlFor="setup-password" style={{ fontSize: "0.85rem" }}>
          Password
          <input
            id="setup-password"
            type="password"
            autoComplete="new-password"
            disabled={blocked || busy}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: "100%", padding: "0.5rem", marginTop: "0.25rem" }}
          />
        </label>
        <label htmlFor="setup-confirm" style={{ fontSize: "0.85rem" }}>
          Confirm password
          <input
            id="setup-confirm"
            type="password"
            autoComplete="new-password"
            disabled={blocked || busy}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            style={{ width: "100%", padding: "0.5rem", marginTop: "0.25rem" }}
          />
        </label>
        {error && (
          <div role="alert" style={{ color: "#c33", fontSize: "0.85rem" }}>
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={blocked || busy}
          style={{ padding: "0.5rem" }}
        >
          {busy ? "Creating…" : "Create admin"}
        </button>
      </form>
    </div>
  );
}
